import axios from 'axios';
import { HMIN_CONFIG, HMAX_CONFIG, TAKEOFF_MAX_ALTITUDE, TAKEOFF_MIN_ALTITUDE, RTH_MAX_ALTITUDE, RTH_MIN_ALTITUDE } from '@/api/http/config'

export const getFlightConfig = async (dock_sn) => {
    try {
        const url = 'https://plugins.cvis.mindlabs.cl' + "/flight_config/" + dock_sn;
        const response = await axios.get(url, {
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
            }}
        );
        console.error(response)
        HMIN_CONFIG.value = response.data.flight_min;
        HMAX_CONFIG.value = response.data.flight_max;
        TAKEOFF_MIN_ALTITUDE.value = response.data.takeoff_min;
        TAKEOFF_MAX_ALTITUDE.value = response.data.takeoff_max;
        RTH_MIN_ALTITUDE.value = response.data.rth_min;
        RTH_MAX_ALTITUDE.value = response.data.rth_max;
        return response.data;

    } catch (error) {
        console.error('Error fetching flight config:', error);
        throw error;
    }
};